module.exports = __webpack_public_path__ + "img/star.d71b821e.gif";